import React from 'react'
import {
  FormControl
} from 'react-bootstrap'
import classes from './HiddenFileInput.module.scss'

export default function HiddenFileInput (props) {
  return (
    <FormControl
      className={classes.hiddenFileInput}
      type='file'
      {...props}
    />
  )
}